import { convertMinutesToHours } from '@nile/mangifera/src/Utils/helpers';
import { Timer } from '@styled-icons/remix-fill';
import {
  ALL_MODULES,
  AsyncCheckbox,
  AsyncRadio,
  AsyncSelect,
  CustomDateField,
  CustomTextField
} from '@nile/components';
import { isEmpty, cloneDeep } from 'lodash';
import React from 'react';

function CustomTextCell(props) {
  const { cell } = props;
  const ticket = cell.row.original;
  const { field, editable, actions, module, getCustomFieldValue } = cell.column;
  let fieldValue = getCustomFieldValue
    ? getCustomFieldValue(ticket, field)
    : ticket?.customFields?.[field.name] || '';
  if (fieldValue && field.uiDataType === 'select') {
    fieldValue = {
      name: fieldValue,
      value: fieldValue,
      label: fieldValue
    };
  } else if (fieldValue && field.uiDataType === 'multi_select') {
    fieldValue = fieldValue.map((el) => {
      return {
        name: el,
        value: el,
        label: el
      };
    });
  }
  const updateSelection = (f, val) => {
    const allCustomFieldValues = !isEmpty(ticket.customFields)
      ? cloneDeep(ticket.customFields)
      : {};
    if (val?.label) {
      allCustomFieldValues[f.name] = val.label;
    } else if (f.uiDataType === 'multi_select') {
      allCustomFieldValues[f.name] = val.map((el) => el.label);
    } else {
      allCustomFieldValues[f.name] = val;
    }
    if (actions.save)
      actions.save({ customFields: allCustomFieldValues }, ticket, props.data);
  };
  return (
    <div>
      <CustomTextField
        defaultValue={fieldValue}
        updateSelection={(v) => {
          updateSelection(field, v);
        }}
        value={fieldValue}
        ticket={ticket}
        field={field}
        editable={editable}
        inlineEdit
        module={module || ALL_MODULES.ticket}
        isMulti={field.uiDataType === 'multi_select'}
      />
    </div>
  );
}

export default CustomTextCell;
